﻿import WebComponent from '../base/WebComponent';
import ProductService from '../../services-js/product.service';
import { FormCustomRoute } from "../../models/formCustomRoute.models";
import EvalService from '../../services-js/eval.service';
import events from '../../services/events';

class Evaluation extends WebComponent {
    static observedAttrs = ["department", "use-clerk", "submit-headline", "close-headline"];
    survyData = null;
    productData = null;
    colorTheme = "";
    routes = [];
    data = {};
    survyGuid = "survyGuid";
    submitted = false;
    closed = false;
    useClerk = false;
    stateRoute = 0;
    areaId = 0;

    init() {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop.toString())
        });
        this.survyGuid = params.g || null;
        return this.fetchData();
    }

    mounted() {
        this.classList.remove("fu-hide");

        this.setTargetProps({
            target: "step-form",
            props: {
                routes: this.routes,
                data: this.data,
                handler: this.handleData
            }
        });
        this.setTargetProps({
            target: "eval-confirm",
            props: {
                slots: this.slots,
                productId: this.productData ? this.productData.id : null,
                relatedProducts: this.productData ? this.productData.relations : null,
                useClerk: this.useClerk,
                areaId: this.areaId
            }
        });
        this.setTargetProps({
            target: "eval-closed",
            props: {
                slots: this.slots,
                productId: this.productData ? this.productData.id : null,
                relatedProducts: this.productData ? this.productData.relations : null,
                useClerk: this.useClerk,
                areaId: this.areaId
            }
        });
    }

    fetchData() {
        return new Promise(async (resolve) => {
            this.survyData = await EvalService.getQuestionnaire({ guid: this.survyGuid, siteId: this.department })
            this.useClerk = this['use-clerk'] == 'true';
            this.submitted = this.survyData.isSubmitted;
            this.closed = this.survyData.isClosed;
            
            if (this.survyData.productId) {
                this.productData = await ProductService.getProduct({
                    siteId: this.department.toString(), 
                    identifier: this.survyData.productId.toString()
                });
                this.areaId = this.productData.areaId;
                if (this.productData.colorThemeId) this.colorTheme = `theme-${this.productData.colorThemeId.toString()}`;
                this.data = sessionStorage.getItem(this.survyGuid) ? JSON.parse(sessionStorage.getItem(this.survyGuid)) : {};
                
                if (!this.closed && !this.submitted) {
                    this.routes = this.survyData.groups.map((group, key) => {
                        return new FormCustomRoute({
                            alias: group.name,
                            description: group.description,
                            component: 'eval-question-group',
                            other: {
                                questions: group.questions,
                                isLast: key + 1 == this.survyData.groups.length
                            }
                        })
                    });
                }
            }

            resolve(true);
        });
    }

    handleData = ({ input, submit = false }) => {
        return new Promise((resolve) => {
            this.data = { ...this.data, ...input };
            sessionStorage.setItem(this.survyGuid, JSON.stringify(this.data));
            this.mounted();

            if (submit) {
                this.submitData();
            }

            resolve(true);
        });
    };

    submitData() {
        EvalService.submitQuestionnaire({
            guid: this.survyGuid,
            data: {
                siteId: this.department,
                answers: this.data
            }
        }).then((res) => {
            if (res.status === 200) {
                this.submitted = true;
                this.render();
            } else {
                res.json().then(async (res) => {
                    if (res.message) {
                        events.createToast({ stays: false, message: res.message });
                    }
                    if (res.questionErrors) {
                        let firstErrorRouteIndex = null;
                        this.routes = await Promise.all(
                            this.routes.map((route, routeIndex) => {
                                return new Promise(async (resolve) => {
                                    if (route.other.questions) {
                                        route.other.questions = await Promise.all(
                                            route.other.questions.map((question) => {
                                                return new Promise((resolve, reject) => {
                                                    const error = res.questionErrors.filter(
                                                        (item) => item.questionGuid === question.guid
                                                    );
                                                    question.error = null;
                                                    if (error.length) {
                                                        question.error = error[0];
                                                        firstErrorRouteIndex =
                                                            firstErrorRouteIndex == null
                                                                ? routeIndex
                                                                : firstErrorRouteIndex;
                                                    }
                                                    resolve(question);
                                                });
                                            })
                                        );
                                    }
                                    resolve(route);
                                });
                            })
                        );
                        this.stateRoute = firstErrorRouteIndex;
                        this.render();
                    }
                });
            }
        });
    }

    template() {
        if (this.productData !== null) {
            let headline = "";
            if (this.submitted) {
                headline = this["submit-headline"] || headline;
            }
            if (!this.submitted && this.closed) {
                headline = this["close-headline"] || headline;
            }

            return `
                <article class="fu-eval ${this.colorTheme}">
                    <header class="fu-eval__header">
                        <div class="fu-eval__header-container" container>
                            <div grid="wrap">
                                ${
                                    headline
                                        ? `<div column="l-10 s-12">
                                    <h1 class="fu-eval__header-title">
                                        ${headline}
                                    </h1>
                                </div>`
                                        : ""
                                }
                                ${
                                    !this.submitted && !this.closed
                                        ? `<step-form class="fu-eval__main" current-route="${this.stateRoute}" column="s-12"></step-form>`
                                        : ""
                                }
                                ${
                                    this.submitted
                                        ? '<eval-confirm class="fu-eval__main" column="s-12"></eval-confirm>'
                                        : ""
                                }
                                ${
                                    !this.submitted && this.closed
                                        ? '<eval-closed class="fu-eval__main" column="s-12"></eval-closed>'
                                        : ""
                                }
                            </div>
                        </div>
                    </header>
                </article>
            `;
        }
        return null;
    }
}
  
  // register component
  customElements.define( 'f-evaluation', Evaluation );
